module.exports = __webpack_public_path__ + "static/img/mTax-02.46a4943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimage/mTax-02.png
// module id = l1tJ
// module chunks = 1